import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { FieldsEntityInstanceResponse } from '@models/api';
import { GridViewModel } from '@models/module/grid';
import { HttpService } from '@shared/services';

import { ModulePresetModel, PresetNumberOption } from './module-config.model';

@Injectable({ providedIn: 'root' })
export class ModulePresetsService {
  private readonly http = inject(HttpService);

  private options(moduleId: number, params: Record<string, unknown> = {}) {
    return {
      useLoader: false,
      httpOptions: { params: this.http.buildHttpParams(params), headers: { moduleId: moduleId.toString() } },
    };
  }

  search(moduleId: number): Observable<ModulePresetModel[]> {
    return this.http
      .post<GridViewModel<ModulePresetModel[]>>('_api/EntityTemplates/Search', {}, this.options(moduleId))
      .pipe(map(result => result?.data ?? []));
  }

  get(moduleId: number, id: number): Observable<ModulePresetModel> {
    return this.http.get<ModulePresetModel>('_api/EntityTemplates/Get', this.options(moduleId, { id }));
  }

  create(moduleId: number, body: Partial<ModulePresetModel>): Observable<number> {
    return this.http.post<number>('_api/EntityTemplates/Create', body, this.options(moduleId));
  }

  update(moduleId: number, body: Partial<ModulePresetModel>) {
    return this.http.put('_api/EntityTemplates/UpdatePreset', body, this.options(moduleId));
  }

  delete(moduleId: number, id: number) {
    return this.http.put('_api/EntityTemplates/Delete', {}, this.options(moduleId, { id }));
  }

  getAvailableNumbers(moduleId: number): Observable<PresetNumberOption[]> {
    return this.http
      .get<PresetNumberOption[]>('_api/EntityTemplates/AvailableNumbersDict', this.options(moduleId))
      .pipe(map(numbers => numbers ?? []));
  }

  getFields(moduleId: number, screenId: number): Observable<FieldsEntityInstanceResponse> {
    return this.http.get<FieldsEntityInstanceResponse>(
      '_api/EntityTemplates/GetFieldsEntityInstance',
      this.options(moduleId, { workflowId: 0, screenId }),
    );
  }
}
